
import { useEffect, useState } from "react";
import ModalWrapper from 'components/ModalWrapper'
import { useTranslation } from "react-i18next";
import { BiDetail } from 'react-icons/bi'
import SectionWrapper from "components/wrappers/SectionWrapper";
import { pickChannel, pickStatus } from ".";
import moment from "moment";
import PropTypes from 'prop-types';

const NotificationDetails = ({ disabled, data }) => {

    const { t } = useTranslation();

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
    }, [isOpen])



    return (
        <>
            <button disabled={!!disabled}
                className={`capitalize focus:outline-none focus:ring-2 focus:ring-offset-2  transition duration-150 ease-in-out 
              rounded  p-2 text-xl ${disabled ? 'bg-gray-200 text-gray-400' : ' text-gray-500 focus:ring-gray-200 hover:bg-gray-200'}`}
                onClick={() => setIsOpen(true)}>
                <BiDetail />
            </button>

            <ModalWrapper
                open={isOpen}
                setOpen={setIsOpen}
            >
                <div key="modal" className="w-[480px]  lg:w-[720px]">

                    {/* Question */}
                    <SectionWrapper
                        title={t('form.notification') + " :"}
                    >

                        <div className="my-4 p-2 bg-gray-50 border-2 border-dashed rounded-r-lg rounded-tl-lg">
                            <div className=" p-2  text-base font-medium text-gray-800">{data?.notification?.title}</div>
                            <div className="p-2  text-sm">{data?.notification?.text}</div>
                        </div>


                        <div className="my-4 flex">
                            <span className="capitalize font-medium text-gray-800 mr-4">{t('form.status')} :</span>
                            <div className="text-sm mx-2">
                                {pickStatus(data?.status[0]._id, data?.status[0].label)}
                            </div>

                        </div>

                        <div className="my-4">
                            <span className="capitalize font-medium text-gray-800 mr-4">{t('form.time')} :</span>
                            <span>
                            {moment(data?.schedule?.time).utc().format("DD MMM YYYY - HH:mm")}
                            </span>
                        </div>

                        <div className="flex items-center my-4">
                            <span className="capitalize font-medium text-gray-800 mr-4 ">{t('form.channels')} :</span>
                            {data?.channels.map((channel,i) => {
                                return <div key={'channel'+i} className="text-xl">

                                    {channel?.enabled && pickChannel(channel?._id, channel?.enabled)}
                                </div>
                            })
                            }
                        </div>






                    </SectionWrapper>


                </div>

            </ModalWrapper>


        </>

    );

}

NotificationDetails.propTypes = {
  disabled: PropTypes.bool,
  data: PropTypes.object,
};

export default NotificationDetails;

